import axios from "axios";

const actions = {
  matchScreenSize(context) {
    const screens = context.state.fullConfig.theme.screens;

    if (window.matchMedia(`(min-width:${screens.xl})`).matches) {
      return 'xl';
    } else if (window.matchMedia(`(min-width:${screens.lg})`).matches) {
      return 'lg';
    } else if (window.matchMedia(`(min-width:${screens.md})`).matches) {
      return 'md';
    } else if (window.matchMedia(`(min-width:${screens.sm})`).matches) {
      return 'sm';
    } else {
      return 'xs';
    }
  },
  setStyle: function (context, item) {
    // Checks if styles are present
    if (typeof item === 'object' && Object.keys(item).indexOf('style') === -1) {
      return false;
    }
    // Checks if styles are not responsive, simply return the object
    if (typeof item.style === 'object' && Object.keys(item.style).indexOf('responsive') === -1) {
      return item.style;
    }
    // Match the media then return the object
    // for(let [breakpoint, style] of Object.entries(item.style.responsive)) {
    // 	if(typeof style === 'object' && breakpoint == this.matchScreenSize) {
    // 		// Matching responsive style.
    // 		return style;
    // 	}
    // }
  },
  openDropdown(context, payload) {
    context.commit('openDropdown', payload);
  },
  getResponsiveStyle(context, styles) {
    console.log(styles);
    let responsiveStyles = '';
    switch (context.getters.screenSize) {
      case 'xl':
        responsiveStyles = styles.xl;
        break;

      case 'lg':
        responsiveStyles = styles.lg;
        break;

      case 'md':
        responsiveStyles = styles.md;
        break;

      case 'sm':
        responsiveStyles = styles.sm;
        break;

      case 'xs':
      default:
        responsiveStyles = styles.xs;
        break;
    }
    return responsiveStyles;
  },
  getMainImg: (context, { page, breakpoint }) => {
    return context.state.pages[page].mainImg.responsive[breakpoint];
  },
  genuineLeatherSVG: (context) => context.state.globals.genuineLeather,
  socialMedia: (context) => {
    return context.state.globals.footer.socialMedia;
  },
  findProduct: async function (context, { sku }) {
    const product = await context.state.axiosWc.get(`${context.getters.getUrlApi}/wc/v3/products/?sku=${sku}`);
    context.commit('SET_PRODUCT', product.data[0]);
  },

  /**
   * @param {active product properties} payload Object
   */
  setVariant: (context, payload) => {
    context.commit('SET_VARIANT', {
      url: `${payload.url}/${payload.colourCode}`,
      colour: payload.colourCode,
    });
  },

  setBrands: async function (context, payload) {
    // axios.all(payload.map(brand => axios.get(`${context.getters.getUrlApi}/media/${brand.featured_media}`)))
    //   .then(axios.spread(function (...res) {
    //     context.commit('SET_BRANDS', res);
    //   }));
    context.commit('SET_BRANDS', payload);
  },

  setCatalogue: async function (context, payload) {
    axios.all(payload.map(item => axios.get(`${context.getters.getUrlApi}/wp/v2/media/${item.featured_media}`)))
      .then(axios.spread(function (...res) {
        context.commit('SET_CATALOGUE', res);
      }));
  },

  setVarietyTab: async function (context, payload) {
    const axios = await context.state.axiosWc;
    // Get the category for the current brand
    const objBrand = await axios.get(`${context.getters.getUrlApi}/wc/v3/products/categories/?slug=${payload.page}`);
    // Get the variety using the ID of the current brand category
    const objBrandVarieties = await axios.get(`${context.getters.getUrlApi}/wc/v3/products/categories/?parent=${objBrand.data[0].id}`);

    context.commit("SET_VARIETY_TAB", { page: payload.page, data: objBrandVarieties.data });
    context.commit("SET_CURRENT_TAB", payload.page);
  },
};

export default actions;
